/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SendDmMessageBody
 */
export interface SendDmMessageBody {
    /**
     * Message content
     * @type {string}
     * @memberof SendDmMessageBody
     */
    content: string;
}

/**
 * Check if a given object implements the SendDmMessageBody interface.
 */
export function instanceOfSendDmMessageBody(value: object): value is SendDmMessageBody {
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function SendDmMessageBodyFromJSON(json: any): SendDmMessageBody {
    return SendDmMessageBodyFromJSONTyped(json, false);
}

export function SendDmMessageBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendDmMessageBody {
    if (json == null) {
        return json;
    }
    return {
        
        'content': json['content'],
    };
}

export function SendDmMessageBodyToJSON(json: any): SendDmMessageBody {
    return SendDmMessageBodyToJSONTyped(json, false);
}

export function SendDmMessageBodyToJSONTyped(value?: SendDmMessageBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content': value['content'],
    };
}

